export const ClickIgnoreDrag = {
  inserted(el, binding) {
    let hasMoved = false;
    el.addEventListener('click', () => {
      if (!hasMoved) {
        binding.value();
      }
    });
    el.addEventListener('mousedown', () => {
      hasMoved = false;
    }, true);
    el.addEventListener('pointerdown', () => {
      hasMoved = false;
    }, true);
    document.addEventListener('mousemove', () => {
      hasMoved = true;
    });
  }
};

